"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.407 15.893a1 1 0 0 1-1.414 0l-1.886-1.886a1 1 0 0 1 0-1.414l5.736-5.736a1 1 0 0 1 1.414 0l1.886 1.886a1 1 0 0 1 0 1.414l-5.736 5.736Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.175 6.175c-.511-.511-.152-1.382.57-1.38l7.632.017c.447 0 .81.364.811.811l.018 7.633c.001.72-.87 1.08-1.38.569l-7.651-7.65Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThickDiagonalArrowIcon20.js.map